export default function ({ redirect }) {
  if (localStorage.getItem('logged')) {
    redirect('/')
  }
}
